import { FORM_VALIDATIONS } from '@riseart/form';
import { subscribeFragment } from 'shared_models/forms/fragments/subscribe';
import { dialingCodes as DIALING_CODES } from 'Countries';

export const EnquireArtworkFormModel = {
  settings: {
    hideRequiredMark: true,
    layout: 'horizontal',
  },
  fields: [
    {
      tag: 'input',
      type: 'email',
      name: 'email',
      validateTrigger: 'onBlur',
      rules: [
        {
          type: 'email',
          message: 'forms.common.validation_messages.not_valid_email',
        },
        {
          required: true,
          message: 'forms.common.validation_messages.not_empty_email',
        },
      ],
      label: 'forms.emailEnquire.placeholder.email',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'firstName',
      validateTrigger: 'onBlur',
      rules: [
        {
          pattern: "^[a-zA-ZÀÁÂÄÇÈÉÊÌÍÒÓÖÔÜàáäâçèéêìíòóöôüß'-\\s]*$",
          message: 'forms.common.validation_messages.not_valid_first_name',
        },
      ],
      label: 'forms.emailEnquire.placeholder.firstName',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'lastName',
      validateTrigger: 'onBlur',
      rules: [
        {
          pattern: "^[a-zA-ZÀÁÂÄÇÈÉÊÌÍÒÓÖÔÜàáäâçèéêìíòóöôüß'-\\s]*$",
          message: 'forms.common.validation_messages.not_valid_last_name',
        },
      ],
      label: 'forms.emailEnquire.placeholder.lastName',
    },
    {
      tag: 'phone',
      type: 'phone',
      name: 'phone',
      validateTrigger: 'onBlur',
      rules: FORM_VALIDATIONS.PHONE,
      label: 'forms.emailEnquire.placeholder.phone',
      dialingCodes: DIALING_CODES,
      initialCountryCode: 'gb',
    },
    {
      tag: 'select',
      name: 'subject',
      options: (intl) =>
        ['pricing', 'additionalImages', 'arrangeViewing', 'shipping', 'sellArtwork', 'other'].map(
          (key) => {
            const text = intl.formatMessage({ id: `forms.emailEnquire.subject.${key}` });

            // the value and the text in the option are the same in this field
            return { value: key, text };
          },
        ),
      initialSelectedIndex: 0,
      label: 'forms.emailEnquire.placeholder.subject',
    },
    {
      tag: 'textarea',
      name: 'message',
      label: 'forms.emailEnquire.placeholder.message',
      maxLength: 500,
    },
    ...subscribeFragment,
  ],
};
